import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import SlideRuler from "slide-ruler";

export default function Height() {
  const navigate = useNavigate();
  const location = useLocation();
  const { goal, activity, age } = location.state || {};
  const slideRulerRef = useRef(null);
  const [selectedHeight, setSelectedHeight] = useState(100);

  useEffect(() => {
    const savedHeight = JSON.parse(localStorage.getItem("height")) || "";
    if (savedHeight !== "") {
      setSelectedHeight(savedHeight);
    }

    const handleValue = (value) => {
      setSelectedHeight(value);
    };

    if (slideRulerRef.current) {
      new SlideRuler({
        el: slideRulerRef.current,
        maxValue: 249,
        heightDigit: 35,
        heightDecimal: 55,
        minValue: 0,
        currentValue: selectedHeight,
        lineWidth: 2,
        colorDecimal: "#fff",
        colorDigit: "#fff",
        fontColor: "#fff",
        divide: 15,
        fontMarginTop: 62,
        handleValue: handleValue,
        direction: "vertical",
      });
    }
  }, []);

  const nextBtnHandler = () => {
    navigate("/weight", {
      state: { goal, activity, age, height: selectedHeight },
    });
    localStorage.setItem("height", JSON.stringify(selectedHeight));
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="heightWeight centeredFlex">
            <h3 className="heightWeightHeading">قد شما ؟</h3>
            <div className="heightWeightSelectorWrapper centeredFlex">
              <div className="rulerSelector centeredFlex">
                {selectedHeight !== null && (
                  <div className="rulerValueWrapper centeredFlex">
                    <span className="rulerValue">{selectedHeight}</span>
                    <span className="rulerUnit">cm</span>
                  </div>
                )}
                <div ref={slideRulerRef}></div>
              </div>
              <img
                className="bodyVector"
                src="/images/body.svg"
                alt="body vector"
              />
            </div>
            <div className="heightWeightBtn">
              <button className="nextQuestion" onClick={nextBtnHandler}>
                بعدی
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
